export const SHOW = 'bulk-set-as-public/SHOW';
export const RESET = 'bulk-set-as-public/RESET';
export const START = 'bulk-set-as-public/START';
export const UPDATE_PROGRESS = 'bulk-set-as-public/UPDATE_PROGRESS';
export const CANCEL = 'bulk-set-as-public/CANCEL';
export const DONE = 'bulk-set-as-public/DONE';
